// no_conflict_lodash.js
import _ from 'lodash';

const _lodash = _;
_.noConflict();

export default _lodash;